import React from 'react'
import axiosSmartSurvey from '../../../api/axios'

export default function useLandregistration() {
    function fetchRegistrationData(setRegistrationData, parcelCode, oldParcel, dn) {
        axiosSmartSurvey({
            method: 'post',
            url: '/landregistration/registrationdata',
            data: {
                parcelCode: parcelCode,
                oldParcel: oldParcel,
                dn: dn
            }
        }).then((response) => {
            response = response.data
            console.log(response)
            setRegistrationData(response)
        }).catch((err) => {
            console.log(err)
        })
    }
    function fetchLandData(setLandRegistrationData, rowData) {
        console.log(rowData)
        axiosSmartSurvey({
            method: 'post',
            url: '/landregistration/landdata',
            data: {
                oldParcel: rowData.old_parcel
            }
        }).then((response) => {
            console.log(response?.data.status === 'OK')
            if (response?.data.status === 'OK') {
                response = response.data.results
                setLandRegistrationData(response)
                console.log(response)
            } else {
                setLandRegistrationData([])
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    function addRegistrationData(registrationdata) {
        console.log(registrationdata)
    }
    async function fetchChangeLog() {
        try {
            const response = await axiosSmartSurvey({
                method: 'post',
                url: '/landregistration/logs'
            })
            console.log(response)
        } catch (err) {
            console.log(err)
        }
    }
    return { fetchRegistrationData, fetchLandData, addRegistrationData, fetchChangeLog }
}
